import { render, staticRenderFns } from "./BGrimmDrugLabelV2.vue?vue&type=template&id=7c75b8d6&"
import script from "./BGrimmDrugLabelV2.vue?vue&type=script&lang=js&"
export * from "./BGrimmDrugLabelV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports